import { shutdown } from "@intercom/messenger-js-sdk";

/**
 * Tears down the messenger and clears the state Intercom keeps for the current
 * user in the browser. Signing out navigates away instead of unmounting, so
 * IntercomProvider's cleanup does not run and callers have to do this
 * themselves.
 */
export const shutdownIntercom = shutdown;
